import { render, staticRenderFns } from "./HomeworkMenuIcon.vue?vue&type=template&id=76c0cc7e&scoped=true&"
import script from "./HomeworkMenuIcon.vue?vue&type=script&lang=js&"
export * from "./HomeworkMenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkMenuIcon.vue?vue&type=style&index=0&id=76c0cc7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0cc7e",
  null
  
)

export default component.exports